/** @format */
import { Heading } from '@mpb-com/feather/components/atoms/heading';
import { HeadingSize } from '@mpb-com/feather/components/atoms/heading/types';
import {
    Skeleton,
    SkeletonVariant,
} from '@mpb-com/feather/components/atoms/skeleton';
import React, { FunctionComponent } from 'react';

import { CardBackground } from '@toucan/client/shared/components/card-background';

import { StyledListingTile } from './listing-tile.styles';
import { ListingTileSkeletonProps } from './types';

export const ListingTileSkeleton: FunctionComponent<
    ListingTileSkeletonProps
> = () => (
    <StyledListingTile data-testid="listing-tile--loading">
        <CardBackground className="tile-background" expandOnHover={false}>
            <div className="tile">
                <div className="tile-image">
                    <Skeleton
                        variant={SkeletonVariant.BLOCK}
                        className="skeleton-image"
                        data-testid="skeleton-image"
                    />
                </div>
                <Heading className="tile-heading" size={HeadingSize.H4}>
                    <Skeleton
                        variant={SkeletonVariant.TEXT}
                        lineCount={2}
                        data-testid="skeleton-title"
                    />
                </Heading>
            </div>
        </CardBackground>
    </StyledListingTile>
);
